module.exports = __webpack_public_path__ + "static/media/PrivacyPolicyPage.60bc4cc1.jpeg";